import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* REST API */
import { filters } from "../../api/Booking"

/* Helpers */
import { utils } from "../../helpers"

/* Icons */
import { CloseIcon, CheckIcon, SearchIcon, CalendarIcon, TableIcon, FilterIcon, InfoIcon, OperatorIcon, StatusIcon } from "./BookingIcons"

/* Timezone — диапазоны строим в ВЫБРАННОЙ зоне, не в зоне машины */
import { nowInTz } from "../../helpers/timezone"

/* DatePicker */
import DatePicker, { registerLocale } from "react-datepicker"
import ru from "date-fns/locale/ru"

/* Sweet alert */
import Swal from "../../helpers/alert"

/* DatePicker Settings */
registerLocale("ru", ru)


/* THE INNER SEARCH APPEARS ONLY WHEN THE LIST OF GAMES IS LONG ENOUGH TO SCROLL */
const SEARCHABLE = 8


/* Widget Booking Filter */
class BookingFilter extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            selected: "all",
            start: null,
            end: null,
            operators: [],
            tables: [],
            status: "",
            allOperators: [],
            allTables: [],
            search: "",
        }
    }

    /* Periods Of The Picker — a reservation belongs to the period as long as its window touches it */
    getPeriods = () => [
        { key: "today", text: t("book.period.today") },
        { key: "tomorrow", text: t("book.period.tomorrow") },
        { key: "yesterday", text: t("book.period.yesterday") },
        { key: "7days", text: t("book.period.next7days") },
        { key: "prev7days", text: t("book.period.last7days") },
        { key: "month", text: t("book.period.thisMonth") },
        { key: "prevmonth", text: t("book.period.prevMonth") },
        { key: "all", text: t("book.period.all") },
    ]

    /* Statuses Of The Picker — the color of a chip is the color the same state keeps in the list */
    getStatuses = () => [
        { key: "", text: t("book.allStatuses"), tone: "blue" },
        { key: "0", text: t("book.state.booked"), tone: "amber" },
        { key: "1", text: t("book.state.arrived"), tone: "green" },
        { key: "missed", text: t("book.state.missed"), tone: "red" },
        { key: "2", text: t("book.state.cancelled"), tone: "slate" },
    ]

    /* Open Action */
    open = ({ selected = "all", start = null, end = null, operators = [], tables = [], status = "" }) => {

        this.setState({
            visible: true,
            selected,
            start,
            end,
            operators: [...operators],
            tables: [...tables],
            status,
            search: "",
        }, () => {
            this.load()
        })
    }

    /* Close Action */
    close = () => {
        this.setState({ visible: false })
    }

    /* Load Action — the operators and the VIP games come strictly inside the scope of the token */
    load = () => {

        /* Check Loaded */
        if (this.state.allOperators.length > 0 || this.state.allTables.length > 0) {
            return
        }

        /* Send to REST API */
        filters().then((response) => {
            if (response.status === 200) {
                this.setState({ allOperators: response.data.operators, allTables: response.data.tables })
            }
        }).catch(() => {
            this.setState({ allOperators: [], allTables: [] })
        })

    }

    /* Games Of The Search */
    getTables = () => {

        /* Fields */
        const { allTables, search } = this.state
        const value = search.trim().toLowerCase()

        /* Check Search */
        if (value === "") {
            return allTables
        }

        /* Send Result */
        return allTables.filter((item) => {

            const name = String(utils.checkValue(item.name, "")).toLowerCase()
            const slug = String(utils.checkValue(item.slug, "")).toLowerCase()
            const studio = String(utils.checkValue(item.studioName, "")).toLowerCase()

            return name.includes(value) || slug.includes(value) || studio.includes(value)
        })
    }

    /* Check Game */
    checkTable = (table) => {
        return this.state.tables.findIndex((item) => parseInt(item.id) === parseInt(table.id)) > -1
    }

    /* Toggle Game */
    toggleTable = (table) => {

        /* Fields */
        const { tables } = this.state

        /* Get Index */
        const index = tables.findIndex((item) => parseInt(item.id) === parseInt(table.id))

        /* Check Index */
        if (index > -1) {
            tables.splice(index, 1)
        }
        else {
            tables.push(table)
        }

        this.setState({ tables })
    }

    /* Check Operator */
    checkOperator = (operator) => {
        return this.state.operators.findIndex((item) => parseInt(item.id) === parseInt(operator.id)) > -1
    }

    /* Toggle Operator */
    toggleOperator = (operator) => {

        /* Fields */
        const { operators } = this.state

        /* Get Index */
        const index = operators.findIndex((item) => parseInt(item.id) === parseInt(operator.id))

        /* Check Index */
        if (index > -1) {
            operators.splice(index, 1)
        }
        else {
            operators.push(operator)
        }

        this.setState({ operators })
    }

    /* Select Period */
    select = (selected) => {

        /* All Period — no border goes to the request */
        if (selected === "all") {
            this.setState({ start: null, end: null, selected })
            return
        }

        /* Today */
        if (selected === "today") {
            this.setState({ start: nowInTz().startOf("day").toDate(), end: nowInTz().endOf("day").toDate(), selected })
            return
        }

        /* Tomorrow */
        if (selected === "tomorrow") {
            this.setState({
                start: nowInTz().add(1, "day").startOf("day").toDate(),
                end: nowInTz().add(1, "day").endOf("day").toDate(),
                selected,
            })
            return
        }

        /* Yesterday */
        if (selected === "yesterday") {
            this.setState({
                start: nowInTz().subtract(1, "day").startOf("day").toDate(),
                end: nowInTz().subtract(1, "day").endOf("day").toDate(),
                selected,
            })
            return
        }

        /* Next Seven Days */
        if (selected === "7days") {
            this.setState({ start: nowInTz().startOf("day").toDate(), end: nowInTz().add(6, "days").endOf("day").toDate(), selected })
            return
        }

        /* Previous Seven Days */
        if (selected === "prev7days") {
            this.setState({ start: nowInTz().subtract(6, "days").startOf("day").toDate(), end: nowInTz().endOf("day").toDate(), selected })
            return
        }

        /* This Month */
        if (selected === "month") {
            this.setState({ start: nowInTz().startOf("month").toDate(), end: nowInTz().endOf("month").toDate(), selected })
            return
        }

        /* Previous Month */
        if (selected === "prevmonth") {
            this.setState({
                start: nowInTz().subtract(1, "month").startOf("month").toDate(),
                end: nowInTz().subtract(1, "month").endOf("month").toDate(),
                selected,
            })
        }

    }

    /* Reset Action */
    reset = () => {
        this.setState({ selected: "all", start: null, end: null, operators: [], tables: [], status: "", search: "" })
    }

    /* Apply Action */
    apply = () => {

        /* Fields */
        const { selected, start, end, operators, tables, status } = this.state
        const { apply } = this.props

        /* Check Dates */
        if (selected !== "all" && (!start || !end)) {
            Swal.fire(utils.notification(t("filter.selectDates"), "error", 2000))
            return
        }

        /* Set Apply */
        apply({ selected, start, end, operators, tables, status })

        /* Close Modal */
        this.close()
    }

    /* Draw Period */
    _period = () => {

        /* Fields */
        const { selected, start, end } = this.state

        return (
            <div className="bkg--section">

                <div className="bkg--section-head">
                    <div className="bkg--section-title">
                        <CalendarIcon size={13} />
                        {t("book.period.title")}
                    </div>
                </div>

                <div className="bkg--chips small">
                    {this.getPeriods().map((item, index) =>
                        <div
                            onClick={() => this.select(item.key)}
                            className={`bkg--pill ${selected === item.key ? "active" : ""}`}
                            key={`${index}`}
                        >
                            {item.text}
                        </div>
                    )}
                </div>

                <div className="bkg--range">

                    <DatePicker
                        selected={start}
                        onChange={(date) => this.setState({ start: date, selected: "period" })}
                        selectsStart
                        startDate={start}
                        endDate={end}
                        maxDate={end}
                        dateFormat="dd.MM.yyyy HH:mm"
                        locale="ru"
                        showTimeSelect
                        placeholderText={t("book.from")}
                    />

                    <DatePicker
                        selected={end}
                        onChange={(date) => this.setState({ end: date, selected: "period" })}
                        selectsEnd
                        startDate={start}
                        endDate={end}
                        minDate={start}
                        dateFormat="dd.MM.yyyy HH:mm"
                        locale="ru"
                        showTimeSelect
                        placeholderText={t("book.to")}
                    />

                </div>

            </div>
        )
    }

    /* Draw Statuses */
    _statuses = () => {

        /* Fields */
        const { status } = this.state

        return (
            <div className="bkg--section">

                <div className="bkg--section-head">
                    <div className="bkg--section-title">
                        <StatusIcon />
                        {t("book.status")}
                    </div>
                </div>

                <div className="bkg--chips small">
                    {this.getStatuses().map((item, index) =>
                        <div
                            onClick={() => this.setState({ status: item.key })}
                            className={`bkg--pill ${item.tone} ${status === item.key ? "active" : ""}`}
                            key={`${index}`}
                        >
                            {item.text}
                        </div>
                    )}
                </div>

            </div>
        )
    }

    /* Draw Operators — a scope with a single operator has nothing to choose from */
    _operators = () => {

        /* Fields */
        const { allOperators, operators } = this.state

        /* Check Operators */
        if (allOperators.length < 2) {
            return null
        }

        return (
            <div className="bkg--section">

                <div className="bkg--section-head">

                    <div className="bkg--section-title">
                        <OperatorIcon />
                        {t("book.operators")}
                        <span className={`bkg--counter ${operators.length === 0 ? "empty" : ""}`}>{operators.length}</span>
                    </div>

                    <div className="bkg--section-actions">
                        <span onClick={() => this.setState({ operators: [...allOperators] })}>{t("filter.selectAll")}</span>
                        <span onClick={() => this.setState({ operators: [] })}>{t("filter.deselectAll")}</span>
                    </div>

                </div>

                <div className="bkg--chips small">
                    {allOperators.map((item, index) =>
                        <div
                            onClick={() => this.toggleOperator(item)}
                            className={`bkg--pill ${this.checkOperator(item) ? "active" : ""}`}
                            key={`${index}`}
                        >
                            {item.name}
                        </div>
                    )}
                </div>

            </div>
        )
    }

    /* Draw Games */
    _tables = () => {

        /* Fields */
        const { allTables, tables, search } = this.state
        const list = this.getTables()

        return (
            <div className="bkg--section">

                <div className="bkg--section-head">

                    <div className="bkg--section-title">
                        <TableIcon />
                        {t("book.games")}
                        <span className={`bkg--counter ${tables.length === 0 ? "empty" : ""}`}>{tables.length}</span>
                    </div>

                    <div className="bkg--section-actions">
                        <span onClick={() => this.setState({ tables: [...this.getTables()] })}>{t("filter.selectAll")}</span>
                        <span onClick={() => this.setState({ tables: [] })}>{t("filter.deselectAll")}</span>
                    </div>

                </div>

                {allTables.length > SEARCHABLE &&
                    <div className="bkg--inner-search">
                        <span className="bkg--inner-search-icon"><SearchIcon size={13} /></span>
                        <input value={search} onChange={(event) => this.setState({ search: event.target.value })} placeholder={t("book.searchByGame")} />
                        {search !== "" &&
                            <div onClick={() => this.setState({ search: "" })} className="bkg--inner-search-clear">
                                <CloseIcon size={11} />
                            </div>
                        }
                    </div>
                }

                {list.length === 0 &&
                    <div className="bkg--chips-empty">{search !== "" ? t("book.nothingFound") : t("book.noGames")}</div>
                }

                <div className="bkg--tables">
                    {list.map((item, index) =>
                        <div
                            onClick={() => this.toggleTable(item)}
                            className={`bkg--table-chip ${this.checkTable(item) ? "active" : ""}`}
                            key={`${index}`}
                        >

                            <div className="bkg--table-box">{this.checkTable(item) && <CheckIcon size={11} />}</div>

                            <div className="bkg--table-text">
                                <div className="bkg--table-name">{utils.checkValue(item.name, item.slug)}</div>
                                <div className="bkg--table-note">{utils.checkValue(item.studioName, item.slug)}</div>
                            </div>

                        </div>
                    )}
                </div>

                <div className="bkg--hint">
                    <InfoIcon size={14} />
                    <span>{t("book.filterHint")}</span>
                </div>

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { visible } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="bkg--modal"
                overlayClassName="bkg--overlay"
                closeTimeoutMS={200}
            >

                <div className="bkg--modal-header">

                    <div className="bkg--modal-icon">
                        <FilterIcon size={18} />
                    </div>

                    <div className="bkg--modal-head-text">
                        <h2>{t("book.filterTitle")}</h2>
                        <p>{t("book.filterSubtitle")}</p>
                    </div>

                    <div onClick={() => this.close()} className="bkg--modal-close">
                        <CloseIcon />
                    </div>

                </div>

                <div className="bkg--modal-body">

                    {/* Draw Period */}
                    {this._period()}

                    {/* Draw Statuses */}
                    {this._statuses()}

                    {/* Draw Operators */}
                    {this._operators()}

                    {/* Draw Games */}
                    {this._tables()}

                </div>

                <div className="bkg--modal-footer space">

                    <div onClick={() => this.reset()} className="bkg--button ghost">{t("book.reset")}</div>

                    <div className="bkg--modal-footer-right">
                        <div onClick={() => this.close()} className="bkg--button ghost">{t("filter.cancel")}</div>
                        <div onClick={() => this.apply()} className="bkg--button primary">{t("filter.apply")}</div>
                    </div>

                </div>

            </Modal>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(BookingFilter)
